import Commons from '../../../../Services/Common/Common';

/**
 * SER_BASIC (중대재해처벌법 이행관리 - 평가 목록) 스키마
 * - fields: 그리드 필드 메타(필수값/라벨/초기값)
 * - mapper: 조회/삭제 API payload 매핑 규칙
 */
export const SER_BASIC_Schema = {
  fields: {
    sdCode: { initial: '', label: '중대재해처벌법코드' },
    evaDate: { initial: '', label: '평가일자' },
    evaName: { initial: '', label: '평가자' },
    evaPoint: { initial: 0, label: '취득점수' },
  },

  mapper: {
    // 목록 조회
    search1: {
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd),
      SearchText: (_, context) => Commons.EncryptAES(context.search?.searchText),
      UserId: (_, context) => context.userInfo?.userid,
    },

    // 선택 행 삭제
    delete1: {
      SdCode: (row) => Commons.EncryptAES(row.sdCode),
      UserId: (_, context) => context.userInfo?.userid,
    },
  },
};

